import { css } from 'styled-components'

import { pxToRem } from '@b-stock/fe-core/design-system'

/**
 * The note popover's width in px. BidCardNoteInline and WatchlistNotePopover
 * both size the popover with it and place it by it.
 */
export const NOTE_POPOVER_WIDTH = 320

/** The least room, in px, the note popover keeps from either viewport edge. */
export const NOTE_POPOVER_VIEWPORT_MARGIN = 16

/**
 * The popover's width, capped to the viewport less a margin on each side, so
 * on a screen narrower than the popover plus both margins it shrinks to fit.
 */
export const notePopoverWidthCss = css`
  width: ${pxToRem(NOTE_POPOVER_WIDTH)};
  max-width: calc(100vw - ${pxToRem(2 * NOTE_POPOVER_VIEWPORT_MARGIN)});
`

/**
 * The popover's `left` edge: as near `anchorLeft` as keeps the margin on both
 * sides. On a screen too narrow for that it sits at the left margin, and
 * {@link notePopoverWidthCss} keeps the right edge a margin in.
 */
export const clampNotePopoverLeft = (
  anchorLeft: number,
  viewportWidth: number
) =>
  Math.max(
    NOTE_POPOVER_VIEWPORT_MARGIN,
    Math.min(
      anchorLeft,
      viewportWidth - NOTE_POPOVER_VIEWPORT_MARGIN - NOTE_POPOVER_WIDTH
    )
  )
